const ChatPanelFirstMessageInfo = () => {
  return (
    <div className="chat-conversation__first-message-info">
      <span>Your first message may take a bit longer as we set things up for you.</span>
    </div>
  );
};

export default ChatPanelFirstMessageInfo;
